import {logger} from 'yougile-util'
import {DataObjectId, SandboxTree} from 'yougile-model'
import {COLUMN_NAMES} from '../constants'
import {addTaskToSubTasks} from './add-task-to-sub-tasks'
import {createTask} from './create-task'
import {ProcessRowsProps} from './process-rows'
import {addToCheckProcessedColumn} from './utils/add-to-check-processed-column'
import {getOrCreateBoard} from './utils/get-or-create-board'
import {getOrCreateColumn} from './utils/get-or-create-column'
import {getOrCreateProject} from './utils/get-or-create-project'
import {getRowValue} from './utils/get-row-value'
import {sendOtherValues} from './utils/send-other-values'
import {strHash} from './utils/str-hash'

export type ProcessRowProps = ProcessRowsProps & {
  row: Record<string, string>
  addedTasks: Record<string, DataObjectId>
  box: SandboxTree
}

export const processRow = (props: ProcessRowProps): void => {
  const {emptyProjectTitle, state, store, projectsCache, row} = props
  const {createdProjectNames, addedTasks, box, company} = props

  state.processedColumns = []
  const companyId = company.id

  const taskTitle = getRowValue(state, row, COLUMN_NAMES.TITLE)
  if (props.processedTasks[taskTitle]) {
    return
  }

  if (!taskTitle) {
    return
  }

  const projectTitle = getRowValue(state, row, COLUMN_NAMES.PROJECT)
  const projectHash = strHash(projectTitle)

  const project = getOrCreateProject(
    {
      title: projectTitle,
      projectsCache,
      createdProjectNames
    },
    emptyProjectTitle
  )

  const boardTitle = getRowValue(state, row, COLUMN_NAMES.BOARD)
  addToCheckProcessedColumn(state, COLUMN_NAMES.BOARD)
  const board = getOrCreateBoard(boardTitle, project)

  const columnTitle = getRowValue(state, row, COLUMN_NAMES.COLUMN)

  addToCheckProcessedColumn(state, COLUMN_NAMES.COLUMN)

  const parentTaskTitle = getRowValue(state, row, COLUMN_NAMES.PARENT_TASK)

  if (parentTaskTitle && !addedTasks[getKey(projectHash, parentTaskTitle)]) {
    for (const parentRow of props.tableDataOrig) {
      const title = getRowValue(state, parentRow, COLUMN_NAMES.TITLE)
      if (title === parentTaskTitle) {
        processRow({...props, row: parentRow})
        props.processedTasks[parentTaskTitle] = true
        break
      }
    }
  }

  if (parentTaskTitle) {
    const parentHash = strHash(parentTaskTitle)
    const parentTaskId = addedTasks[getKey(projectHash, parentHash)]

    const parentTask = parentTaskId && box.getHub(parentTaskId)
    if (parentTask?.data) {
      const task = createTask({taskTitle, state, store, row, board})
      addTaskToSubTasks(parentTask, task)
      const rowTitleHash = strHash(row.Title)
      addedTasks[getKey(projectHash, rowTitleHash)] = box.get(task.id).id
      return
    } else {
      logger.error(`Parent not found for ${taskTitle}`)
    }
  }

  const column = getOrCreateColumn(columnTitle, board)
  const columnId = column.id
  const task = createTask({
    taskTitle,
    state,
    store,
    row,
    columnId,
    companyId,
    board
  })

  const taskTitleHash = strHash(taskTitle)

  addedTasks[getKey(projectHash, taskTitleHash)] = task.id

  sendOtherValues(state, task, row)
}

const getKey = (projectHash: string, taskHash: string): string => {
  return `${projectHash}-${taskHash}`
}
